(function($) {
  // tabela-jc.js
  init($);

  var limit = 4;
  var current_limit = limit;
  var offset = 0;
  var results_number = 0;
  var can_scroll_down;

  marca = "";
  modelo = "";
  ano = "";

  // Recarrega os resultados quando o filtro é alterado e seta URL com parâmetros selecionados
  function reload_results() {
    params = {};
    var order_by = $("#order_by").val();
    var base_url = window.location.pathname;
    var query = "";

    if (tipo_veiculo.length) {
      query += "?tipo_veiculo=" + encodeURIComponent(tipo_veiculo);
    }
    if (marca.length) {
      query += "&marca=" + encodeURIComponent(marca);
    }
    if (modelo.length) {
      query += "&modelo=" + encodeURIComponent(modelo);
    }
    if (ano.length) {
      query += "&ano=" + ano;
    }
    if (preco_min.length) {
      query += "&preco_min=" + preco_min.replace(/\./g, "");
    }
    if (preco_max.length) {
      query += "&preco_max=" + preco_max.replace(/\./g, "");
    }
    window.history.pushState("", "", base_url + query);

    if (order_by && order_by.length) {
      query += "&order_by=" + order_by;
    }
    tabelaJcPushVirtualPageView(query);
    $("#results").load("/wp-content/themes/estadao/tabela-jc/templates/tabela-jc-filtro-resultados.php" + query, update_ads);
  }


  // Clique em tipo de veículo
  $(".tipo_veiculo").click(function() {
    tipo_veiculo = $(this).children('input').val();
    marca = "";
    modelo = "";
    ano = "";

    limit = 4;
    current_limit = limit;
    offset = 0;

    get_opcoes_marca(tipo_veiculo);
    reset_field("#modelo", '<option value="">Modelo</option>', true);
    reset_field("#ano", '<option value="">Ano</option>', true);
    reload_results();
  });

    // Mudança de marca
  $("#marca").change(function() {
    marca = $("#marca").val();
    modelo = "";
    ano = "";

    if (marca.length) {
      get_opcoes_modelo(tipo_veiculo, marca);
    } else {
      reset_field("#modelo", '<option value="">Modelo</option>', true);
    }

    reset_field("#ano", '<option value="">Ano</option>', true);

    reload_results();
  });

  // Mudança de modelo
  $("#modelo").change(function() {
    // marca = $("#marca").val();
    modelo = $("#modelo").val();
    ano = "";

    if (modelo.length) {
      get_opcoes_ano(tipo_veiculo, marca, modelo);
    } else {
      reset_field("#ano", '<option value="">Ano</option>', true);
    }

    reload_results();
  });

  // Mudança de ano
  $("#ano").change(function() {
    ano = $("#ano").val();
    reload_results();
  });

  // Mudança de preço mínimo
  $("#preco_min").change(function() {
    preco_min = $("#preco_min").val();
    reload_results();
  });

  // Mudança de preço máximo
  $("#preco_max").change(function() {
    preco_max = $("#preco_max").val();
    reload_results();
  });

  // Carrega mais resultados na tela
  function load_more_results() {
    offset += limit;
    current_limit += limit;
    results_number = $('.jc-inline-card').length;
    var query = window.location.search + "&offset=" + offset + "&results_number=" + results_number;

    tabelaJcPushVirtualPageView(query);
    $("#order_by").val("");
    $(".result-list:last").load("/wp-content/themes/estadao/tabela-jc/templates/tabela-jc-filtro-resultados.php" + query + " .result-list > *", update_ads);
  }

  function update_ads() {
    // Mostra os anúncios não exibidos
    $("div[id^='div-gpt-ad-5396546-scroll-']:not('.displayed')").each(function() {
      var id = $(this).attr('id');

      DFP.renderHtml({
        'selector': '#'+ id,
        'targets':{
          'formato':'hinfi'
        },
        'screenmap': 'Horizontal_728_N_T_250'
      });

      $(this).addClass('displayed');
    });

    results_number = $('.jc-inline-card').length;
    $("#results_number").html(results_number);
    $("#results").append('<div class="result-list"></div>');
    can_scroll_down = true;
  }


  // Identifica o fim scroll da página
  $(window).scroll(function () {
    if(can_scroll_down && ($(window).scrollTop() + $(window).height() === $(document).height())) {
      can_scroll_down = false;
      load_more_results();
    }
  });

  // Identifica operações de carregamento Ajax
  $("#results").on({
    ajaxStart: function() {
      if (offset === 0) {
        $(".jc-loading").addClass("jc-loading-show");
        $(".has-jc-loading").addClass("jc-loading-hide");
      } else {
        $(".jc-loading:last").addClass("jc-loading-show");
      }
    },
    ajaxStop: function() {
      if (offset === 0) {
        $(".jc-loading").removeClass("jc-loading-show");
        $(".has-jc-loading").removeClass("jc-loading-hide");
      } else {
        $(".jc-loading").removeClass("jc-loading-show");
      }
    }
  });

  // Limpar filtro
  $("#clear_form").click(function() {
    // Limpa os parâmetros
    marca = "";
    modelo = "";
    ano = "";
    preco_min = "";
    preco_max = "";

    // Limpa os campos do form
    reset_field("#modelo", '<option value="">Modelo</option>', true);
    reset_field("#ano", '<option value="">Ano</option>', true);

    reload_results();
  });

  // Botão de ordenação dos resultados
  $("#order_by").change(function() {
    var query = window.location.search + "&order_by=" + $(this).val();
    if (current_limit > limit) {
      query += "&limit=" + current_limit;
    }
    tabelaJcPushVirtualPageView(query);
    $("#results").load("/wp-content/themes/estadao/tabela-jc/templates/tabela-jc-filtro-resultados.php" + query, update_ads);
  });

  update_ads();
})(jQuery);
